export const data = [
  'SourcePage.UserTableHeader.NAME',
  'SourcePage.UserTableHeader.PHONE',
  'SourcePage.UserTableHeader.ROLE',
  'SourcePage.UserTableHeader.ONLINE',
];
